<div class="category-v2-list" *ngIf="productCategory && totalProducts">
  <div class="overlay-section-overlay category-v2-list-wrap relative">
    <img  loading="lazy"  [src]="productCategory.image" 
       [alt]="productCategory.image" />
    <div class="category-v2-content">
      <h4>
        <a
          [routerLink]="['/' + lang + '/products']"
          class="text-inverse text-capitalize"
          >{{ productCategory.category_type }}</a
        >
      </h4>
      <p class="mb-0 text-inverse">{{ totalProducts }} Products</p>
    </div>
  </div>
</div>
